// The design-system migration's copy, one file per area so parallel work never edits the same lines.
// i18n.ts's locale files spread `uiCopy.<locale>` into their dictionaries.
import { academyCopy } from "./academy";
import { blindCopy } from "./blind";
import { cardsCopy } from "./cards";
import { continueCopy } from "./continue";
import { entitiesCopy } from "./entities";
import { flightsCopy } from "./flights";
import { friendRequestsCopy } from "./friendRequests";
import { kitCopy } from "./kit";
import { peopleCopy } from "./people";
import { presenceCopy } from "./presence";
import { privacyCopy } from "./privacy";
import { sessionsCopy } from "./sessions";
import { shareCopy } from "./share";
import { socialCopy } from "./social";
import { socialHubCopy } from "./socialHub";
import { tastingCopy } from "./tasting";
import { tastingShareCopy } from "./tastingShare";
import { togetherCopy } from "./together";
import { unseenCopy } from "./unseen";
import { updatesCopy } from "./updates";
import { winesCopy } from "./wines";

export const uiCopy = {
  nl: {
    ...kitCopy.nl,
    ...academyCopy.nl,
    ...flightsCopy.nl,
    ...winesCopy.nl,
    ...entitiesCopy.nl,
    ...socialCopy.nl,
    ...friendRequestsCopy.nl,
    ...sessionsCopy.nl,
    ...shareCopy.nl,
    ...peopleCopy.nl,
    ...presenceCopy.nl,
    ...cardsCopy.nl,
    ...blindCopy.nl,
    ...privacyCopy.nl,
    ...tastingCopy.nl,
    ...tastingShareCopy.nl,
    ...togetherCopy.nl,
    ...continueCopy.nl,
    ...unseenCopy.nl,
    ...updatesCopy.nl,
  },
  en: {
    ...kitCopy.en,
    ...academyCopy.en,
    ...flightsCopy.en,
    ...winesCopy.en,
    ...entitiesCopy.en,
    ...socialCopy.en,
    ...friendRequestsCopy.en,
    ...sessionsCopy.en,
    ...shareCopy.en,
    ...peopleCopy.en,
    ...presenceCopy.en,
    ...cardsCopy.en,
    ...blindCopy.en,
    ...privacyCopy.en,
    ...tastingCopy.en,
    ...tastingShareCopy.en,
    ...togetherCopy.en,
    ...continueCopy.en,
    ...unseenCopy.en,
    ...updatesCopy.en,
  },
  de: {
    ...kitCopy.de,
    ...academyCopy.de,
    ...flightsCopy.de,
    ...winesCopy.de,
    ...entitiesCopy.de,
    ...socialCopy.de,
    ...socialHubCopy.de,
    ...friendRequestsCopy.de,
    ...sessionsCopy.de,
    ...shareCopy.de,
    ...peopleCopy.de,
    ...presenceCopy.de,
    ...cardsCopy.de,
    ...blindCopy.de,
    ...privacyCopy.de,
    ...tastingCopy.de,
    ...tastingShareCopy.de,
    ...togetherCopy.de,
    ...continueCopy.de,
    ...unseenCopy.de,
    ...updatesCopy.de,
  },
  fr: {
    ...kitCopy.fr,
    ...academyCopy.fr,
    ...flightsCopy.fr,
    ...winesCopy.fr,
    ...entitiesCopy.fr,
    ...socialCopy.fr,
    ...socialHubCopy.fr,
    ...friendRequestsCopy.fr,
    ...sessionsCopy.fr,
    ...shareCopy.fr,
    ...peopleCopy.fr,
    ...presenceCopy.fr,
    ...cardsCopy.fr,
    ...blindCopy.fr,
    ...privacyCopy.fr,
    ...tastingCopy.fr,
    ...tastingShareCopy.fr,
    ...togetherCopy.fr,
    ...continueCopy.fr,
    ...unseenCopy.fr,
    ...updatesCopy.fr,
  },
  es: {
    ...kitCopy.es,
    ...academyCopy.es,
    ...flightsCopy.es,
    ...winesCopy.es,
    ...entitiesCopy.es,
    ...socialCopy.es,
    ...socialHubCopy.es,
    ...friendRequestsCopy.es,
    ...sessionsCopy.es,
    ...shareCopy.es,
    ...peopleCopy.es,
    ...presenceCopy.es,
    ...cardsCopy.es,
    ...blindCopy.es,
    ...privacyCopy.es,
    ...tastingCopy.es,
    ...tastingShareCopy.es,
    ...togetherCopy.es,
    ...continueCopy.es,
    ...unseenCopy.es,
    ...updatesCopy.es,
  },
  it: {
    ...kitCopy.it,
    ...academyCopy.it,
    ...flightsCopy.it,
    ...winesCopy.it,
    ...entitiesCopy.it,
    ...socialCopy.it,
    ...socialHubCopy.it,
    ...friendRequestsCopy.it,
    ...sessionsCopy.it,
    ...shareCopy.it,
    ...peopleCopy.it,
    ...presenceCopy.it,
    ...cardsCopy.it,
    ...blindCopy.it,
    ...privacyCopy.it,
    ...tastingCopy.it,
    ...tastingShareCopy.it,
    ...togetherCopy.it,
    ...continueCopy.it,
    ...unseenCopy.it,
    ...updatesCopy.it,
  },
  pt: {
    ...kitCopy.pt,
    ...academyCopy.pt,
    ...flightsCopy.pt,
    ...winesCopy.pt,
    ...entitiesCopy.pt,
    ...socialCopy.pt,
    ...socialHubCopy.pt,
    ...friendRequestsCopy.pt,
    ...sessionsCopy.pt,
    ...shareCopy.pt,
    ...peopleCopy.pt,
    ...presenceCopy.pt,
    ...cardsCopy.pt,
    ...blindCopy.pt,
    ...privacyCopy.pt,
    ...tastingCopy.pt,
    ...tastingShareCopy.pt,
    ...togetherCopy.pt,
    ...continueCopy.pt,
    ...unseenCopy.pt,
    ...updatesCopy.pt,
  },
} as const;
